import { render, staticRenderFns } from "./SignUpIntegrated.vue?vue&type=template&id=06b063e7"
import script from "./SignUpIntegrated.vue?vue&type=script&lang=js"
export * from "./SignUpIntegrated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports